import React from 'react';
import { Link } from "react-router-dom";
import { Label } from '../atoms/label';

import useMedia from 'use-media';

export const SoloInputConfirmStartTime = (props) => {

    const isWideTablet = useMedia({ maxWidth: '960px' });
    const isWidePhone = useMedia({ maxWidth: '480px' });

    return (
        <div className="soloConfirm_inputTextWrapper">
            <div className="soloConfirm_inputTitleArea">
                <Label label={props.label1} className="soloConfirm_inputTitle" />
                <div className="soloConfirm_startTimeTextLink1">
                    <Link style={styles.link} to="/reserve/golf/soloStartTime" >変更</Link>
                </div>
            </div>
            <div className="soloConfirm_startTimeInputTextform" >
                <div className="soloConfirm_startTimeInputTextName" >
                    <div className="soloConfirm_startTimeLabelGroup">
                        <Label label={props.label2} className="soloConfirm_startTimeLabel" />
                    </div>
                </div>
                <div className="soloConfirm_startTimeTextLink2">
                    <Link style={styles.link} to="/reserve/golf/soloStartTime" >変更</Link>
                </div>
            </div>
        </div>
    );
}
const styles = {
    inputName: {
        width: "40%",
    },
    inputName2: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
    },
    inputTextform: {
        width: "70%",
        display: "flex",
    },
    labelgloup: {
        display: "flex",
    },
    labelgloup2: {
        display: "block",
        // marginBottom: "10px",
    },
    inputTextName: {
        width: "70%",
    },
    inputTextName2: {
        width: "100%",
    },
    inputTextform: {
        width: "100%",
        display: "flex",
    },
    inputTextform2: {
        width: "100%",
        display: "flex",
    },
    inputTextLink: {
        width: "30%",
        textAlign: "right",
        color: "#6f6f6f",
    },
    inputTextLink2: {
        display: "none",
    },
    inputTextLink3: {
        display: "none",
    },
    inputTextLink4: {
        width: "30%",
        textAlign: "center",
        color: "#6f6f6f",
    },
    link: {
        color: "#6f6f6f",
        fontSize: "small",
    }
}